module.exports = __webpack_public_path__ + "img/Avatar-34.fda6a850.svg";